import styles from "@/styles/components/GridBackdrop.module.css"

/**
 * The faint grid every frame sits on.
 *
 * Two patches — upper-right and lower-left — fading out toward the centre,
 * never a full-bleed graph paper. It is decoration and NOT a layout grid: no
 * content is aligned to it, and changing `--grid-cell` must not move anything.
 *
 * Fixed rather than absolute so it stays put while a long page scrolls; a grid
 * that scrolls with the content reads as a texture printed on the page, which is
 * the one thing it is not.
 */
export default function GridBackdrop() {
  return <div className={styles.backdrop} aria-hidden="true" />
}
